import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import Info from 'components/shared/Info'
import Text from 'components/shared/Text'
import { GenericTechnicalErrorProps } from './GenericTechnicalError.types'

export const GenericTechnicalError = ({
    variant = 'error',
}: GenericTechnicalErrorProps) => {
    const ErrorMessage = useMemo(() => {
        switch (variant) {
            case 'warning':
                // warning version, with toned down colors
                return (
                    <Info
                        color="info_warning"
                        variantType="error"
                        align="center"
                        hasNoBackground
                        hasBorder
                    >
                        <Text variant="bodySmall" color="grayscale_900">
                            <FormattedMessage
                                id="global.error.generic_technical_issue"
                                defaultMessage="_"
                            />
                        </Text>
                    </Info>
                )
            case 'warning_borderless':
                // similar to 'warning', but without borders
                return (
                    <Info
                        color="info_warning"
                        variantType="error"
                        align="center"
                        isFullWidthContent
                        hasNoBackground
                    >
                        <Text variant="bodySmall" color="grayscale_900">
                            <FormattedMessage
                                id="global.error.generic_technical_issue"
                                defaultMessage="_"
                            />
                        </Text>
                    </Info>
                )
            default:
                // default, red message
                return (
                    <Info color="error" variantType="warning">
                        <FormattedMessage
                            id="global.error.generic_technical_issue"
                            defaultMessage="_"
                        />
                    </Info>
                )
        }
    }, [variant])

    return ErrorMessage
}
